import React from "react";
import LegalPage from "@/components/common/LegalPage";

export default function Disclaimer() {
  return (
    <LegalPage
      seo={{ title: "Disclaimer | Premier Global Sourcing", description: "Important information about the scope of the Premier Global Sourcing website and services.", path: "/disclaimer" }}
      eyebrow="Legal"
      title="Disclaimer"
      updated="[ADD DATE]"
      breadcrumbs={[{ label: "Disclaimer" }]}
      sections={[
        { heading: "General information", body: "The content on this website is provided for general information about our coordination services. It does not constitute a binding offer, professional advice or a guarantee of any outcome." },
        { heading: "Service positioning", body: "Premier Global Sourcing acts as a coordination partner connecting product requirements, suppliers, trading and logistics planning. We do not claim to own factories, warehouses, vehicles or international offices unless verified information is later supplied and clearly stated." },
        { heading: "Regulated services", body: "Freight, inspection, customs clearance and other regulated activities may be coordinated through relevant qualified partners where applicable. We do not represent ourselves as a licensed customs broker or freight carrier." },
        { heading: "No fabricated claims", body: "We do not publish fabricated statistics, ratings, testimonials, certifications or client references. Where information is not yet available, editable placeholders are used." },
        { heading: "Company identity", body: "This website relates specifically to Premier Global Sourcing (Private) Limited and should not be confused with similarly named companies in other countries." },
      ]}
    />
  );
}
